<h1 id="title" class="title">Register</h1>

<form [formGroup]="form" aria-labelledby="title">

	<div class="form-control-group">
		<label class="label">User Name:</label>
		<input nbInput
			name="username"
			placeholder="User Name"
			autofocus
			fullWidth
			formControlName="username"
			[status]="form.controls['username'].dirty ? (form.controls['username'].invalid  ? 'danger' : 'success') : ''"
			[required]="true"
			[minlength]="1"
			[maxlength]="255"
			[attr.aria-invalid]="form.controls['username'].invalid && form.controls['username'].touched ? true : null">
		<ng-container *ngIf="form.controls['username'].invalid && form.controls['username'].touched">
			<p class="error-message" *ngIf="form.controls['username'].errors?.required">
				User name is required!
			</p>
			<p class="error-message" *ngIf="form.controls['username'].errors?.minlength || form.controls['username'].errors?.maxlength">
				User name should contains
				from 1
				to 255
				characters
			</p>
		</ng-container>
	</div>

	<div class="form-control-group">
		<label class="label">First Name:</label>
		<input nbInput
			name="first_name"
			placeholder="First Name"
			autofocus
			fullWidth
			formControlName="first_name"
			[status]="form.controls['first_name'].dirty ? (form.controls['first_name'].invalid  ? 'danger' : 'success') : ''"
			[required]="true"
			[minlength]="1"
			[maxlength]="255"
			[attr.aria-invalid]="form.controls['first_name'].invalid && form.controls['first_name'].touched ? true : null">
		<ng-container *ngIf="form.controls['first_name'].invalid && form.controls['first_name'].touched">
			<p class="error-message" *ngIf="form.controls['first_name'].errors?.required">
				First name is required!
			</p>
			<p class="error-message" *ngIf="form.controls['first_name'].errors?.minlength || form.controls['first_name'].errors?.maxlength">
				First name should contains
				from 1
				to 255
				characters
			</p>
		</ng-container>
	</div>

	<div class="form-control-group">
		<label class="label">Last Name:</label>
		<input nbInput
			name="last_name"
			placeholder="Last Name"
			autofocus
			fullWidth
			formControlName="last_name"
			[status]="form.controls['last_name'].dirty ? (form.controls['last_name'].invalid  ? 'danger' : 'success') : ''"
			[required]="true"
			[minlength]="1"
			[maxlength]="255"
			[attr.aria-invalid]="form.controls['last_name'].invalid && form.controls['last_name'].touched ? true : null">
		<ng-container *ngIf="form.controls['last_name'].invalid && form.controls['last_name'].touched">
			<p class="error-message" *ngIf="form.controls['last_name'].errors?.required">
				Last name is required!
			</p>
			<p class="error-message" *ngIf="form.controls['last_name'].errors?.minlength || form.controls['last_name'].errors?.maxlength">
				Last name should contains
				from 1
				to 255
				characters
			</p>
		</ng-container>
	</div>

	<div class="form-control-group">
		<label class="label" for="input-email">Email address:</label>
		<input nbInput
			id="input-email"
			name="email"
			pattern=".+@.+..+"
			placeholder="Email address"
			fullWidth
			formControlName="email"
			[status]="form.controls['email'].dirty ? (form.controls['email'].invalid  ? 'danger' : 'success') : ''"
			[required]="true"
			[attr.aria-invalid]="form.controls['email'].invalid && form.controls['email'].touched ? true : null">
		<ng-container *ngIf="form.controls['email'].invalid && form.controls['email'].touched">
			<p class="error-message" *ngIf="form.controls['email'].errors?.required">
				Email is required!
			</p>
			<p class="error-message" *ngIf="form.controls['email'].errors?.pattern">
				Email should be the real one!
			</p>
		</ng-container>
	</div>

	<div class="form-control-group">
		<label class="label">Password:</label>
		<input nbInput
			type="password"
			name="password"
			placeholder="Password"
			fullWidth
			formControlName="password"
			[status]="form.controls['password'].dirty ? (form.controls['password'].invalid  ? 'danger' : 'success') : ''"
			[required]="true"
			[minlength]="6"
			[maxlength]="255"
			[attr.aria-invalid]="form.controls['password'].invalid && form.controls['password'].touched ? true : null">
		<ng-container *ngIf="form.controls['password'].invalid && form.controls['password'].touched">
			<p class="error-message" *ngIf="form.controls['password'].errors?.required">
				Password is required!
			</p>
			<p class="error-message" *ngIf="form.controls['password'].errors?.minlength || form.controls['password'].errors?.maxlength">
				Password should contains
				from 6
				to 255
				characters
			</p>
		</ng-container>
	</div>

	<div class="form-control-group">
		<label class="label">Repeat password:</label>
		<input nbInput
			type="password"
			name="passwordConfirm"
			placeholder="Confirm Password"
			fullWidth
			formControlName="passwordConfirm"
			[status]="form.controls['passwordConfirm'].dirty ? (form.controls['passwordConfirm'].invalid || form.controls['password'].value != form.controls['passwordConfirm'].value  ? 'danger' : 'success') : ''"
			[required]="true"
			[attr.aria-invalid]="form.controls['passwordConfirm'].invalid && form.controls['passwordConfirm'].touched ? true : null">
		<ng-container *ngIf="form.controls['passwordConfirm'].invalid && form.controls['passwordConfirm'].touched">
			<p class="error-message" *ngIf="form.controls['passwordConfirm'].errors?.required">
				Password confirmation is required!
			</p>
			<p class="error-message" *ngIf="form.controls['password'].value != form.controls['passwordConfirm'].value && !form.controls['passwordConfirm'].errors?.required">
				Password does not match the confirm form.controls['password'].
			</p>
		</ng-container>
	</div>

	<div class="form-control-group accept-group">
		<nb-checkbox [formControl]="agreeTerms" [required]="true">
			Agree to <a href="#" target="_blank"><strong>Terms & Conditions</strong></a>
		</nb-checkbox>
	</div>

	<nb-alert *ngIf="!!errorMessage" outline="danger" role="alert">
		<p class="alert-title"><b>{{ 'Errors.RegisterErrorMessage' | translation }}</b></p>
		<p>
			{{errorMessage}}
		</p>
	</nb-alert>

	<nb-alert *ngIf="!!successMessage" outline="success" role="alert">
		<p class="alert-title"><b>Hooray!</b></p>
		<p>
			{{successMessage}}
		</p>
	</nb-alert>

	<button nbButton
			fullWidth
			status="success"
			[disabled]="form.invalid || !agreeTerms.value"
			(click)="register()">
		Register
	</button>
</form>

<section class="another-action" aria-label="Sign in">
  	Already have an account? <a class="text-link" routerLink="../login">Log in</a>
</section>
